
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setUserEmail,
  setAuthToken,
  setUserDetails,
  logoutUser,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  updateUserProfileRequest,
  updateUserProfileSuccess,
  updateUserProfileFailure,
} from "./authSlice";
import  authAPI  from "../../services/authAPI";
import  userAPI  from "../../services/companyUserAPI";
import companyUserAPI from "../../services/companyUserAPI";

export const loginUser = createAsyncThunk(
  "user/login",
  async ({ email, password }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await authAPI.login({ email, password });

      // Store email and token
      dispatch(setUserEmail(email));
      dispatch(setAuthToken(response.data.token));

      // Store token in localStorage
      sessionStorage.setItem("authToken", response.data.token);

      dispatch(apiRequestSuccess());
      dispatch(setUserDetails(response.data.user));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Login failed. Please check your credentials.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "user/verifyOTP",
  async ({ otp, email }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await authAPI.verifyOTP({ otp, email });

      // Store token and user details
      const { token, user } = response.data.data;

      if (token) {
        sessionStorage.setItem("authToken", token);
        dispatch(setAuthToken(token));
        dispatch(setUserDetails(user));
      }

      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Invalid OTP. Please try again.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const resendOTP = createAsyncThunk(
  "user/resendOTP",
  async (email, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await authAPI.resendOTP(email);
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to resend OTP. Please try again.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Logout thunk
export const logout = createAsyncThunk(
  "user/logout",
  async (_, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      await authAPI.logout();
      sessionStorage.removeItem("authToken");
      dispatch(logoutUser());
      dispatch(apiRequestSuccess());
    } catch (error) {
      console.error("Logout error:", error);
      // Still remove the token and log out the user even if the API call fails
      sessionStorage.removeItem("authToken");
      dispatch(logoutUser());
      dispatch(apiRequestSuccess());
    }
  }
);

// Get user profile thunk
export const getUserProfile = createAsyncThunk(
  "user/getProfile",
  async (userId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await userAPI.getUser(userId);
      console.log("sar", response);
      dispatch(setUserDetails(response.data.data));
      console.log("sir", response);
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user profile.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const UpdateUserProfile = createAsyncThunk(
  "user/updateProfile",
  async ({userId, userData}, { dispatch }) => {
    dispatch(updateUserProfileRequest());
    try {
      const response = await companyUserAPI.updateUser(userId, userData);
      // Update user details in the store
      dispatch(updateUserProfileSuccess(response.data.user));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update user profile.";
      dispatch(updateUserProfileFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// Reset password thunk
export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (resetData, { dispatch }) => {
    dispatch(resetPasswordRequest());
    try {
      const response = await authAPI.resetPassword(resetData);
      dispatch(resetPasswordSuccess(response.data.message));
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Password reset failed. Please try again.";
      dispatch(resetPasswordFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

// export const forgotPassword = createAsyncThunk(
//     'user/forgotPassword',
//     async (email, { dispatch }) => {
//       dispatch(forgotPasswordRequest());
//       try {
//         const response = await authAPI.resendOTP(email);
//         dispatch(forgotPasswordSuccess(response.data.message));
//         return response.data;
//       } catch (error) {
//         const errorMessage = error.response?.data?.message || 'Forgot password request failed. Please try again.';
//         dispatch(forgotPasswordFailure(errorMessage));
//         throw new Error(errorMessage);
//       }
//     }
//   );
